// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"31cda80f","453":"3fd8ff22","788":"bdb50a9d","840":"3887949a"}[chunkId] + ".chunk.js";
};